'use client';

import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'casino' | 'danger' | 'outline' | 'ghost' | 'transparent';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'casino',
  size = 'md',
  isLoading = false,
  children,
  className = '',
  disabled,
  ...props
}) => {
  const baseClasses = 'font-bold text-transform uppercase letter-spacing-1 transition-all duration-300 cursor-pointer relative overflow-hidden disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variantClasses = {
    casino: 'btn-casino',
    danger: 'btn-danger',
    outline: 'border-2 border-solid  btn-outline border-yellow-500 text-yellow-500 bg-transparent hover:bg-yellow-500 hover:text-black',
    ghost: 'bg-transparent text-yellow-500 hover:bg-yellow-500 hover:bg-opacity-10',
    transparent: 'btn-transparent',
  };
  
  const sizeClasses = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <button
      className={classes}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-current"></div>
          <span className="ml-2">Loading...</span>
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
